import SBINModal from "./SBINModal";

export default function ConfirmModalRose({
  open,
  title = "Confirm",
  message,
  confirmText = "Yes",
  cancelText = "No",
  onConfirm,
  onCancel,
  showClose = true,
}) {
  if (!open) return null;

  return (
    <SBINModal
      isOpen={open}
      onClose={onCancel}
      title={title}
      size="sm"
      fitContent={true}
      showClose={showClose}
      footer={
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="rounded-full border border-slate-300 px-5 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded-full bg-rose-500 px-5 py-2 text-sm font-semibold text-white hover:bg-rose-600"
          >
            {confirmText}
          </button>
        </div>
      }
    >
      <p className="text-sm text-slate-700 whitespace-pre-line">{message}</p>
    </SBINModal>
  );
}
